
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/excursions/sankt-peterburg",
      function () {
        return require("private-next-pages/excursions/sankt-peterburg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/excursions/sankt-peterburg"])
      });
    }
  